import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Loader2, PlusCircle, Save, Tag } from 'lucide-react';

import { useAddExpenseCategoryMutation } from '@/store/ExpenseCategoryApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import { toast } from 'sonner';

const AddCategoryBtn = () => {
  const [Category, setCategory] = React.useState('');
  const { user } = useSelector((state: RootState) => state.user);
  const [addCategoryFn, { isSuccess, isLoading }] =
    useAddExpenseCategoryMutation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    addCategoryFn({ Token: user?.token, ledger: Category });
  };

  React.useEffect(() => {
    if (isSuccess) {
      toast.success('Category Added Successfully');
      setCategory('');
      document
        .querySelector('[data-state="open"]')
        ?.setAttribute('data-state', 'closed');
    }
  }, [isSuccess]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="px-4 py-2 bg-[#26BDB0] text-white rounded-lg hover:bg-[#49ccc1e2] transition-colors flex items-center gap-2">
          <Tag className="w-5 h-5" />
          Add Category
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-primary">
            <h1> Add New Category</h1>
          </DialogTitle>
          <DialogDescription>
            Enter the Category details below. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-6 pb-4">
            <div className="grid gap-2">
              <Label
                htmlFor="Category"
                className="text-sm font-medium text-muted-foreground"
              >
                Category Name
              </Label>
              <Input
                id="Category"
                value={Category}
                onChange={(e) => setCategory(e.target.value)}
                className="text-foreground"
                placeholder="Enter Category name..."
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="submit"
              className="gap-2 bg-[#26BDB0] hover:bg-primary/90"
            >
              {isLoading ? (
                <Loader2 className="h-4 w-4" />
              ) : (
                <Save className="h-4 w-4" />
              )}
              Save Category
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddCategoryBtn;
